export default "/yacht-chunk-eth.062c5726ca3981f5ffd8681919056794.svg";